const initialState = {
    changedCalibrationData: {},
    rateDecimal: 2
}
  
const Calibration = (state = initialState, action) => {
    switch (action.type) {
        case "SET_CHANGED_CALIBRATION_DATA":
            let tmpState = {...state.changedCalibrationData}
            let payload = action.payload
            tmpState[Object.keys(payload)[0]] = payload[Object.keys(payload)[0]]
            state = {
                ...state,
                changedCalibrationData: tmpState
            }
            return state
        case "CLEAR_CALIBRATION_DATA":
            state = {
                changedCalibrationData: {}
            }
            return state
        case "SET_RATE_DECIAL":
                state = {
                    ...state,
                    rateDecimal: action.payload
                }
                return state
        default:
            return state
    }
}

export default Calibration
